import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { COMPANY, CONTACT, NAV_ITEMS, SERVICES } from "../data/content";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050910]">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-8 lg:grid-cols-[1.3fr_.7fr_.7fr] lg:px-10">
      <div>
        <img src={COMPANY.logo} alt="CLACH Global Services Limited" className="h-16 w-auto" data-testid="footer-logo" />
        <p className="mt-6 max-w-md text-sm leading-7 text-slate-400">
          Innovative resource and solutions provider serving energy, oil and gas, environment, and maritime markets.
        </p>
        <div className="mt-8 space-y-4 text-sm text-slate-300" data-testid="footer-contact-details">
          {CONTACT.offices.map((office) => (
            <p key={office.city} className="flex gap-3" data-testid={`footer-office-${office.city.toLowerCase()}`}>
              <MapPin size={17} className="mt-0.5 shrink-0 text-amber-400" />
              <span><strong className="text-white">{office.city}:</strong> {office.address}</span>
            </p>
          ))}
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="flex gap-3 transition-colors hover:text-amber-300"><Mail size={17} className="mt-0.5 text-amber-400" />{CONTACT.email}</a>
          <a href={`tel:${CONTACT.phones[0].replace(/\s/g, "")}`} data-testid="footer-phone-link" className="flex gap-3 transition-colors hover:text-amber-300"><Phone size={17} className="mt-0.5 text-amber-400" />{CONTACT.phones[0]}</a>
        </div>
      </div>
      <div>
        <h3 className="font-mono text-xs uppercase tracking-[0.28em] text-blue-400">Navigate</h3>
        <div className="mt-6 grid gap-3">
          {NAV_ITEMS.map((item) => (
            <Link key={item.path} to={item.path} data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-slate-400 transition-colors hover:text-white">
              {item.label}
            </Link>
          ))}
        </div>
      </div>
      <div>
        <h3 className="font-mono text-xs uppercase tracking-[0.28em] text-blue-400">Capabilities</h3>
        <div className="mt-6 grid gap-3">
          {SERVICES.map((service) => (
            <Link key={service.slug} to={`/services/${service.slug}`} data-testid={`footer-service-${service.slug}`} className="group flex items-center justify-between text-sm text-slate-400 transition-colors hover:text-white">
              {service.title} <ArrowUpRight size={14} className="opacity-0 transition-opacity group-hover:opacity-100" />
            </Link>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 px-4 py-6 text-center font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">
      <a href="https://siliconpay.com.ng" target="_blank" rel="noreferrer" data-testid="silicon-pay-tech-link" className="transition-colors hover:text-amber-300">
        © Silicon Pay Tech 2026
      </a>
    </div>
  </footer>
);
